import Tree from './Tree';

// export types
export type { TreeProps } from './Tree';
export type { TreeNodeProps } from './TreeNode';

// export components
export { Tree };
export default Tree;
